import { gql } from '@apollo/client'

export const TASKS_QUERY = gql`
  query tasks($processingId: ID!) {
    tasks(processingId: $processingId) {
      collection {
        completedAt
        createdAt
        done
        dueDate
        id
        processingId
        title
        updatedAt
        caseIdentifier
        taskCategory {
          id
          name
          color
          textColor
          createdAt
          updatedAt
        }
      }
    }
  }
`
